import { useTranslation } from 'react-i18next';
import { Jumbo } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';

import ViewerFeedbackTabs from './ViewerFeedbackTabs';
import ViewerFeedbackButtons from './ViewerFeedbackButtons';
import OutgoingFeedbackList from './OutgoingFeedbackList';

export default function ViewerOutgoingFeedback() {
	const { t } = useTranslation();

	const viewer = useAuthenticatedUser();
	const userID = viewer.id;

	const query = graphql.useOutgoingFeedbackResponsesQuery({
		variables: { userID, last: 10 },
	});

	return (
		<>
			<Jumbo
				title={t('feedback.outgoing.title')}
				description={t('feedback.outgoing.description')}
				button={<ViewerFeedbackButtons />}
				footer={<ViewerFeedbackTabs />}
			/>
			<OutgoingFeedbackList userID={userID} query={query} />
		</>
	);
}
